import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs/internal/Observable";
import { AppStore } from "../store/app.store";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardSigo implements CanActivate {

  constructor(private appStore: AppStore,
    private route: ActivatedRoute,
    private router: Router) { }

  canActivate(
    activateRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.appStore.sessionAction.esSesionValida()) {
      return true;
    }
    else {
      var str = state.url;
      var splitted = str.split("?token=", 2);
      const token = splitted[1]; // this.route.snapshot.queryParamMap.get('token');
      if (token) {
        this.appStore.sessionAction.login(token);
        const v = this.appStore.state.session.displayUser;
        var rutaSintoken = splitted[0];
        this.router.navigate([rutaSintoken]);
        return true
      }
      else {
        location.href = environment.loginSigo + location.origin + state.url;
      }
      return null;
    }
  }

}
